import { LeftArrow, RightArrow } from 'shared-widget-components/src/components/Icons';
import { WinePackageLink } from './WinePackageLink';

interface WineHeaderProps {
  title: string;
  textColor: string;
  scrollLeft: () => void;
  scrollRight: () => void;
  isScrollbarVisible: boolean;
  isScrollableToLeft: boolean;
  isScrollableToRight: boolean;
}

/**
 * The WinePackagesHeader component is a React component that displays a title, the number of wine
 * packages, and navigation buttons for scrolling through the packages.
 * @param {WineHeaderProps}  - - `title`: The title of the wine package header.
 * @returns The WinePackagesHeader component is returning a JSX element.
 */
const WinesScrollbarHeader = ({ title, textColor, scrollLeft, scrollRight, isScrollbarVisible, isScrollableToLeft, isScrollableToRight }: WineHeaderProps) => {
  return (
    <div className='flex justify-between'>
      <h1 className='font-body font-bold  mt-2 min-[350px]:text-[26px] sm:text-[28px] sm:ml-2' style={{ color: textColor }}>
        {title}
      </h1>
      <div className=' min-[350px]:hidden sm:flex items-center mt-2'>
        {isScrollbarVisible && (
          <>
            <button
              type='button'
              onClick={scrollLeft}
              className={`mr-2 w-8 h-8 bg-white text-black opacity-100  rounded-full flex items-center justify-center ${!isScrollableToLeft ? '  opacity-50' : ''}`}
              disabled={!isScrollableToLeft}
              style={{ cursor: !isScrollableToLeft ? 'not-allowed' : 'pointer' }}
            >
              <LeftArrow />
            </button>
            <button
              type='button'
              onClick={scrollRight}
              className={`w-8 h-8 bg-white text-black rounded-full flex items-center justify-center ${!isScrollableToRight ? ' opacity-50' : ''}`}
              disabled={!isScrollableToRight}
              style={{ cursor: !isScrollableToRight ? 'not-allowed' : 'pointer' }}
            >
              <RightArrow />
            </button>
          </>
        )}
        <WinePackageLink textColor={textColor} />
      </div>
    </div>
  );
};

export default WinesScrollbarHeader;
